import { Component } from '@angular/core';

@Component({
  selector: 'app-actions-btn',
  templateUrl: 'actions-btn.component.html',
  styleUrls: ['actions-btn.component.scss']
})
export class ActionsBtnComponent {
}
